/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import React from "react";

interface StatusCardProps {
  label: string;
  value: string | number;
  color: string;
  icon: string;
  trend: string;
  status: string;
  selectedStatus: string;
  onClick: (status: string) => void;
}

const StatusCard: React.FC<StatusCardProps> = ({
  label,
  value,
  color,
  icon,
  trend,
  status,
  selectedStatus,
  onClick,
}) => {
  const isActive = selectedStatus === status;

  return (
    <button
        onClick={() => onClick(status)}
        style={{ borderTopColor: color }}
        className={`bg-white p-1 rounded-xl 
        h-[95px]
        border-t-[5px] border-l border-t border-slate-100
        border-r-0 border-b-0
        shadow-sm flex flex-col text-left gap-0.5 hover:shadow-md transition-all group
        focus:outline-none focus:ring-0 active:outline-none ${
          isActive ? "shadow-md" : "shadow-sm"
        }`}
    >
      <div className="flex justify-between items-start">
        <p className="text-[9px] font-black text-slate-300 uppercase tracking-[0.2em] mt-[3px] ml-[16px]">
          {label}
        </p>
        <span
          className={`material-symbols-outlined text-xl transition-colors ${
            isActive
              ? "text-slate-800"
              : "text-slate-200 group-hover:text-slate-400"
          }`}
        >
          {icon}
        </span>
      </div>

      <p className="text-xl font-black text-slate-800 -mt-[8px] ml-[16px]">{value}</p>

      <p className="text-[8px] font-black text-slate-300 uppercase -mt-[8px] ml-[16px] italic tracking-[0.1em]">
        {trend}
      </p>
    </button>
  );
};

export default StatusCard;